"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDefaultIssuePlacementLink = exports.getSelectedMarkupsParamString = void 0;
var _getAccHostname = require("../browser/getAccHostname");
var _sheets = require("../../state/redux/ducks/sheets");
var _hooks = require("../../state/redux/hooks");
var _issuesCollection = require("../../state/redux/ducks/issuesCollection");
var _featureFlags = require("../featureFlags");
/**
 * In the wiki at https://wiki.autodesk.com/pages/viewpage.action?spaceKey=ANNO&title=Precise+Markup+Backlinking
 * and up until may 2022 we were supposed to include `fbms` in the URL,
 * but that may not be true going forward, so we put it behind a FF
 */
const getSelectedMarkupsParamString = _ref => {
  let {
    issueId,
    shouldUseFbmsWrapper
  } = _ref;
  if (!issueId) {
    return "";
  }
  const selection = {
    fbt: "issue",
    fbids: [issueId]
  };
  return "&markups=".concat(encodeURIComponent(JSON.stringify({
    selection: {
      ...(shouldUseFbmsWrapper ? {
        fbms: [selection]
      } : selection)
    }
  })));
};
exports.getSelectedMarkupsParamString = getSelectedMarkupsParamString;
const useDefaultIssuePlacementLink = () => {
  const selectSheetAssociationByIssueId = (0, _hooks.useSelector)(_sheets.getSheetAssociationByIssueId);
  const getIssue = (0, _hooks.useSelector)(_issuesCollection.getIssueById);
  const {
    value: readFromIssuePlacements
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.ReadFromIssuePlacements);
  return _ref2 => {
    let {
      projectId,
      sheet,
      document,
      issueId,
      productId = "docs",
      isIframe = false
    } = _ref2;
    if (sheet) {
      // @TODO: this is always linking to the "build" application -- is there an equivalent in docs
      // that we should be linking to, or is it ok that stamp placement always links to
      // the sheets tab of build, even if the issues log is in docs?
      return "https://".concat((0, _getAccHostname.getAccHostname)(), "/build/sheets/projects/").concat(projectId, "?entityId=").concat(sheet.id).concat(getSelectedMarkupsParamString({
        issueId,
        shouldUseFbmsWrapper: false
      })).concat(isIframe ? "&iframeHosted=1&issuePlacement=1" : "");
    }
    if (document) {
      var _issue$placements, _issue$linkedDocument, _sheetAssociation$vie;
      const issue = getIssue(issueId);
      const issueViewable = readFromIssuePlacements ? issue === null || issue === void 0 || (_issue$placements = issue.placements) === null || _issue$placements === void 0 || (_issue$placements = _issue$placements[0]) === null || _issue$placements === void 0 ? void 0 : _issue$placements.viewable : issue === null || issue === void 0 || (_issue$linkedDocument = issue.linkedDocuments) === null || _issue$linkedDocument === void 0 || (_issue$linkedDocument = _issue$linkedDocument[0]) === null || _issue$linkedDocument === void 0 ? void 0 : _issue$linkedDocument.details.viewable;
      const sheetAssociation = selectSheetAssociationByIssueId(issueId);
      const viewableGuid = (_sheetAssociation$vie = sheetAssociation === null || sheetAssociation === void 0 ? void 0 : sheetAssociation.viewableGuid) !== null && _sheetAssociation$vie !== void 0 ? _sheetAssociation$vie : issueViewable === null || issueViewable === void 0 ? void 0 : issueViewable.guid;
      return "https://".concat((0, _getAccHostname.getAccHostname)(), "/").concat(productId, "/files/projects/").concat(projectId, "?folderUrn=").concat(encodeURIComponent(document.parentFolderUrn), "&entityId=").concat(encodeURIComponent(document.urn), "&viewModel=detail&moduleId=folders&issueId=").concat(issueId).concat(getSelectedMarkupsParamString({
        issueId,
        shouldUseFbmsWrapper: false
      })).concat(isIframe ? "&iframeHosted=1&issuePlacement=1" : "").concat(viewableGuid ? "&viewableGuid=".concat(viewableGuid) : "");
    }
    return "";
  };
};
exports.useDefaultIssuePlacementLink = useDefaultIssuePlacementLink;
//# sourceMappingURL=placementUtils.js.map